module.exports = __webpack_public_path__ + "img/companytwo.9d54025b.png";